import { render, staticRenderFns } from "./ChiSiamoView.vue?vue&type=template&id=03808ae6&scoped=true&"
import script from "./ChiSiamoView.vue?vue&type=script&lang=js&"
export * from "./ChiSiamoView.vue?vue&type=script&lang=js&"
import style0 from "./ChiSiamoView.vue?vue&type=style&index=0&id=03808ae6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03808ae6",
  null
  
)

export default component.exports